export default __webpack_public_path__ + "static/media/art.3aa1fe49.jpg";